export type ArrayOrderingOptions = 'start-to-end' | 'end-to-start' | 'random';

/**
 * Orders an array of objects based on the specified ordering type
 * @param array The input array of objects
 * @param orderType The type of ordering to apply
 * @returns A new array with the specified ordering
 */
export function orderArray<T>(
  array: T[],
  orderType: ArrayOrderingOptions,
): T[] {
  switch (orderType) {
    case 'start-to-end':
      return [...array];

    case 'end-to-start':
      return [...array].reverse();

    case 'random':
      return shuffleArray(array);

    default:
      return array;
  }
}

export function shuffleArray<T>(array: T[]): T[] {
  const copy = [...array];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1)); // Random index
    [copy[i] as unknown, copy[j] as unknown] = [copy[j], copy[i]]; // Swap elements
  }
  return copy;
}

export function isScrambled<T>(arr1: T[], arr2: T[]): boolean {
  if (arr1.length !== arr2.length) return false; // Just a safety check

  return arr1.some((item, index) => item !== arr2[index]);
}

export function itemsToArray(items?: string, delimiter = '|'): string[] {
  if (!items || items.length === 0) return [];
  return items.split(delimiter).map((i: string) => i.trim());
}
